import type { ProductEntity } from '../../domain/entities/Product';
import type { ProductManagementService } from '../../domain/services/ProductManagementService';
import type { CreateProductDTO } from '../dtos/product/CreateProductDTO';
import type { ProductResponseDTO } from '../dtos/product/ProductResponseDTO';

export interface CreateProductUseCase {
  execute(dto: CreateProductDTO): Promise<ProductResponseDTO>;
}

export default class CreateProductUseCaseImpl implements CreateProductUseCase {
  constructor(
    private readonly productManagementService: ProductManagementService
  ) {}

  async execute(dto: CreateProductDTO): Promise<ProductResponseDTO> {
    try {
      const product = await this.productManagementService.createProduct(dto);
      return this.mapToResponseDTO(product);
    } catch (error) {
      throw new Error(`Failed to create product: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  private mapToResponseDTO(product: ProductEntity): ProductResponseDTO {
    const jsonProduct = product.toJSON();
    return {
      id: jsonProduct._id,
      name: jsonProduct.name,
      sku: jsonProduct.sku,
      description: jsonProduct.description,
      barcode: jsonProduct.barcode,
      category: jsonProduct.category,
      cost: jsonProduct.cost,
      price: jsonProduct.price,
      minQuantity: jsonProduct.minQuantity,
      maxQuantity: jsonProduct.maxQuantity,
      isActive: jsonProduct.isActive,
      createdAt: jsonProduct.createdAt,
      updatedAt: jsonProduct.updatedAt
    };
  }
}
